var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : '')},[_c('v-content',{staticClass:"pa-4"},[_c('iframe',{attrs:{"src":"http://172.20.4.13:9901/#/dashboard","width":"100%","height":"700px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }